export default "__VITE_ASSET__tbg7w4tJ__"